<template>
    <div class="client-card">
        <div class="card">
            <div class="card-body">
                <div class="card-title"><h4>{{ theClient.name }}</h4></div>
                <p class="card-text">
                    <table class="table table-sm">
                        <thead>

                        </thead>
                        <tbody>
                            <tr>
                                <td>Tipo cliente</td>
                                <td>{{ theClient.client_type.name }}</td>
                            </tr>
                            <tr>
                                <td>Tipo documento</td>
                                <td>{{ theClient.identification_type.name }}</td>
                            </tr>
                            <tr>
                                <td>Documento</td>
                                <td>{{ theClient.document }}</td>
                            </tr>
                            <tr>
                                <td>Dirección</td>
                                <td>{{ theClient.adress }}</td>
                            </tr>
                            <tr>
                                <td>Teléfono</td>
                                <td>{{ theClient.phone }}</td>
                            </tr>
                            <tr>
                                <td>Sitio web</td>
                                <td>{{ theClient.website }}</td>
                            </tr>
                            <tr>
                                <td>E-mail</td>
                                <td>{{ theClient.email }}</td>
                            </tr>
                            <tr>
                                <td>Código</td>
                                <td>{{ theClient.code }}</td>
                            </tr>
                            <tr>
                                <td>Slug</td>
                                <td>{{ theClient.slug }}</td>
                            </tr>
                        </tbody>
                    </table>
                </p>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            theClient: {
                type: Object,
                required: true
            }
        }
    }
</script>